import React, { useContext, useEffect } from 'react';
import GalleryCard from './GalleryCard';
import { getData } from '../../lib/utils';
import { useParams } from 'react-router-dom';
import { Context } from "../../components/contexts/AppContext";
import VideoThumbnailExtractor from './VideoThumbnailExtractor';

const GallerySection = () => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const { galleryId } = useParams();

  const templateid =  appState?.currentGalleryData?.templateid;
const selectedVideos = appState?.currentGalleryData?.selectedVideos || []; 
const galleryData = selectedVideos
  .map(id => appState.videoArr.find(video => video._id === id))
  .filter(Boolean); // null ya undefined ko remove karega


  

  const handlePlay = async (item) => {
    window.dispatchEvent(new Event("STOP_BACKGROUND_AUDIO"));
    const data = await getData(`chapters/getChaptersByVideo/${item._id}`);
    if (data) {
      setAppState((prevState) => ({
        ...prevState,
        currentChapterArr: data,
        currentVideoUrl: item.url,
        currentVideoId:item._id,
        modalData: {
          ...prevState.modalData,
          type: "ChapterListModal",
          isOpen: true,
          isPlayAll: false
        }
      }));
    }
  };

  // Template Rendering Logic
  const renderTemplate = () => {
    
    switch (templateid) {
      case 1:
      default:
        return (
          <div className="w-full flex flex-col sm:flex-row gap-4 p-2 ">
            {galleryData.map((item, index) => (
              <GalleryCard
                key={index}
                image={item.image}
                title={item.title}
                item={item}
                videoid={item._id}
                onPlay={() => handlePlay(item)}
              />
            ))}
          </div>
        );
      case 2:
        return (<div className="relative w-full min-h-screen ">
          <div className="absolute top-0 right-0 w-[400px]  flex flex-col gap-4 items-end">
            {galleryData.map((item, index) => (
              <GalleryCard
                key={index}
                image={item.image}
                title={item.title}
                item={item}
                videoid={item._id}
                onPlay={() => handlePlay(item)}
              />
            ))}
          </div>
        </div>
        );
      case 3:
        return (
          <div className="flex flex-wrap justify-center gap-6">
            {galleryData.map((item, index) => (
              <GalleryCard
                key={index}
                image={item.image}
                title={item.title}
                item={item}
                videoid={item._id}
                onPlay={() => handlePlay(item)}
              />
            ))}
          </div>
        );
      case 4:
        return (
          <div className="space-y-4">
            {galleryData.map((item, index) => (
              <div key={index} className="w-full border-b pb-2">
                <GalleryCard
                  image={item.image}
                  title={item.title}
                  item={item}
                  videoid={item._id}
                  onPlay={() => handlePlay(item)}
                />
              </div>
            ))}
          </div>
        );
      case 5:
        return (
          <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
            {galleryData.map((item, index) => (
              <GalleryCard
                key={index}
                image={item.image}
                title={item.title}
                item={item}
                videoid={item._id}
                onPlay={() => handlePlay(item)}
              />
            ))}
          </div>
        );
    }
  };

  return (
    <div id="GallerySection" className="w-full h-full relative sm:overflow-x-auto ">
      <div className="w-full h-full relative  overflow-y-hidden">
        <div id="ttttttt" className="w-full relative flex flex-row  md:overflow-x-auto">
          {renderTemplate()}
        </div>
      </div>
    </div>
  );
};

export default GallerySection;
